import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5700cda2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listItem" }
const _hoisted_2 = { class: "listItemHeader" }
const _hoisted_3 = { class: "vendorName" }
const _hoisted_4 = { class: "toggleContainer" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_6 = { class: "vendorPurposeOrFeatureLabel" }
const _hoisted_7 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_8 = { class: "vendorPurposeOrFeatureText" }
const _hoisted_9 = {
  key: 0,
  class: "vendorPurposeOrFeatureLabel"
}
const _hoisted_10 = { class: "vendorPurposeOrFeatureID" }
const _hoisted_11 = { class: "vendorPurposeOrFeatureText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")!
  const _component_Vue3SlideUpDown = _resolveComponent("Vue3SlideUpDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.purpose.name), 1),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_ChevronIcon, {
          onClick: _ctx.expandCollapseClick,
          class: _normalizeClass(_ctx.collapseClass)
        }, null, 8, ["onClick", "class"])
      ])
    ]),
    _createVNode(_component_Vue3SlideUpDown, {
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expanded) = $event)),
      duration: 200,
      class: "listItemDetail"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.introDescription), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedDescriptions, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "vendorPurposeOrFeatureDesc"
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(i+1), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(s), 1)
          ]))
        }), 128)),
        (_ctx.formattedCanNotDescriptions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Vendors cannot:"))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formattedCanNotDescriptions, (s, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i+1000,
            class: "vendorPurposeOrFeatureDesc"
          }, [
            _createElementVNode("div", _hoisted_10, _toDisplayString(i+1), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(s), 1)
          ]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}